// KROSSO Predictive Search — mobile icon-morph row (header.liquid) below
// 769px, desktop/tablet anchored dropdown (header-search.liquid) at 769px+.
// Same predictive-search logic drives both; only the open/close chrome differs.

(function () {
  'use strict';

  const trigger = document.getElementById('krosso-search-trigger');
  if (!trigger) return;

  // ---- Shared: format price / build result markup ----
  function formatPrice(value) {
    const raw = Number(value);
    if (!Number.isFinite(raw)) return '';
    const amount = raw >= 100000 ? raw / 100 : raw;
    return '₹' + amount.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function buildItem(product) {
    const img = product.featured_image?.url || product.image?.url || '';
    const imgSrc = img ? img.replace(/\.(jpg|jpeg|png|webp|gif)/, '_120x120.$1') : '';
    const price = product.price ? formatPrice(product.price) : '';

    return `
      <a class="ksearch-item" href="${product.url}">
        ${imgSrc
          ? `<img class="ksearch-item__img" src="${imgSrc}" alt="${product.title}" loading="lazy">`
          : `<div class="ksearch-item__img-placeholder"></div>`
        }
        <div class="ksearch-item__info">
          <div class="ksearch-item__title">${product.title}</div>
          ${price ? `<div class="ksearch-item__price">${price}</div>` : ''}
        </div>
      </a>
    `;
  }

  function normalizeLocalProduct(product) {
    const image = product.featured_image?.src || product.featured_image || product.images?.[0] || '';
    return {
      title: product.title || '',
      url: product.url || (product.handle ? `/products/${product.handle}` : '#'),
      price: product.price,
      featured_image: { url: image }
    };
  }

  function localProducts(query) {
    const list = window.ShopifyData?.products || window.products || [];
    const q = query.toLowerCase();
    return list
      .filter(product => {
        const title = (product.title || '').toLowerCase();
        const handle = (product.handle || '').toLowerCase();
        return title.includes(q) || handle.includes(q);
      })
      .slice(0, 6)
      .map(normalizeLocalProduct);
  }

  // ---- Factory: wires up one search block (mobile row or desktop dropdown) ----
  function initBlock(ids) {
    const input     = document.getElementById(ids.input);
    const results   = document.getElementById(ids.results);
    const inner     = document.getElementById(ids.inner);
    const empty     = document.getElementById(ids.empty);
    const hint      = document.getElementById(ids.hint);
    const queryEcho = document.getElementById(ids.queryEcho);
    if (!input || !results || !inner || !empty || !hint || !queryEcho) return null;

    function hideResults() {
      results.hidden = true;
      empty.hidden = true;
      inner.innerHTML = '';
    }

    function showProducts(products, query) {
      if (!products.length) {
        results.hidden = true;
        empty.hidden = false;
        queryEcho.textContent = query;
        return;
      }
      empty.hidden = true;
      inner.innerHTML = products.map(buildItem).join('') +
        `<a class="ksearch-view-all" href="/search?q=${encodeURIComponent(query)}">View all results for "${query}"</a>`;
      results.hidden = false;
    }

    let currentQuery = '';
    let debounceTimer = null;

    async function search(query) {
      currentQuery = query;
      if (!query || query.trim().length < 2) {
        hideResults();
        hint.hidden = false;
        return;
      }
      hint.hidden = true;
      const fallbackProducts = localProducts(query);
      showProducts(fallbackProducts, query);
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Search failed');
        const data = await res.json();
        if (query !== currentQuery) return;
        const products = data?.resources?.results?.products || [];
        if (products.length > 0 || fallbackProducts.length === 0) showProducts(products, query);
      } catch (err) {
        console.warn('KROSSO search error:', err);
      }
    }

    input.addEventListener('input', () => {
      const val = input.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => search(val), 200);
    });

    input.addEventListener('keydown', e => {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}`;
      }
    });

    function reset() {
      input.value = '';
      hideResults();
      hint.hidden = false;
    }

    return { input, reset };
  }

  const mobile = initBlock({
    input: 'krosso-search-input-m', results: 'krosso-search-results-m', inner: 'krosso-search-results-inner-m',
    empty: 'krosso-search-empty-m', hint: 'krosso-search-hint-m', queryEcho: 'krosso-search-query-echo-m'
  });
  const desktop = initBlock({
    input: 'krosso-search-input-d', results: 'krosso-search-results-d', inner: 'krosso-search-results-inner-d',
    empty: 'krosso-search-empty-d', hint: 'krosso-search-hint-d', queryEcho: 'krosso-search-query-echo-d'
  });

  // ---- Mobile: icon-morph row, part of the header capsule ----
  const headerContent = document.querySelector('.header__content');
  const rowM = document.getElementById('ksearch-row-m');
  const drawerM = document.getElementById('ksearch-drawer-m');
  const backM = document.getElementById('ksearch-back-m');
  const closeM = document.getElementById('ksearch-close-m');

  function openMobile() {
    if (!headerContent) return;
    headerContent.classList.add('ksearch-open');
    drawerM?.classList.add('is-active');
    trigger.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');
    setTimeout(() => mobile?.input.focus(), 260);
  }
  function closeMobile() {
    if (!headerContent) return;
    headerContent.classList.remove('ksearch-open');
    drawerM?.classList.remove('is-active');
    trigger.classList.remove('is-active');
    trigger.setAttribute('aria-expanded', 'false');
    mobile?.reset();
  }

  backM?.addEventListener('click', closeMobile);
  closeM?.addEventListener('click', closeMobile);

  // ---- Desktop: header grows in place (variant C, approved) ----
  const dropdownD = document.getElementById('ksearch-grow-d');
  const closeD = document.getElementById('ksearch-close-d');

  function openDesktop() {
    dropdownD?.classList.add('is-open');
    dropdownD?.setAttribute('aria-hidden', 'false');
    trigger.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');
    setTimeout(() => desktop?.input.focus(), 260);
  }
  function closeDesktop() {
    dropdownD?.classList.remove('is-open');
    dropdownD?.setAttribute('aria-hidden', 'true');
    trigger.classList.remove('is-active');
    trigger.setAttribute('aria-expanded', 'false');
    desktop?.reset();
  }

  closeD?.addEventListener('click', closeDesktop);
  document.addEventListener('click', (e) => {
    if (!dropdownD?.classList.contains('is-open')) return;
    if (trigger.contains(e.target) || dropdownD.contains(e.target)) return;
    closeDesktop();
  });

  // ---- Trigger: which breakpoint is live right now ----
  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  trigger.addEventListener('click', () => {
    if (isMobile()) {
      const isOpen = headerContent?.classList.contains('ksearch-open');
      isOpen ? closeMobile() : openMobile();
    } else {
      const isOpen = dropdownD?.classList.contains('is-open');
      isOpen ? closeDesktop() : openDesktop();
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeMobile(); closeDesktop(); }
  });

  // Viewport can cross the breakpoint (rotate / resize) while open — close
  // whichever variant no longer applies so it doesn't get stuck open+hidden.
  window.addEventListener('resize', () => {
    if (isMobile()) closeDesktop(); else closeMobile();
  });

})();
